import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import Card from 'components/Card';
import ModalHeadline from 'components/ModalHeadline';
import Text from 'components/Text';
import Stack from 'components/Stack';
import Panel from 'components/Panel';
import BulletList from 'components/BulletList';
import Button from 'components/Button';
function ContentContributionsModal(_ref) {
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = 'content-contribution-rule-title';
  return /*#__PURE__*/React.createElement(Modal, {
    id: "content-contribution-rule",
    "aria-labelledby": titleId,
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    px: "xs"
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: t('modal_allow_content_contribution_title'),
    titleId: titleId
  }), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, t('modal_allow_content_contribution_intro')), /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "modal_allow_content_contribution_abilities_included_subheading"
  }, "The option \u201CAllow anyone with access to add their own content\u201D will give everyone with access to the playlist these", ' ', /*#__PURE__*/React.createElement("strong", null, "basic content contribution abilities:")), /*#__PURE__*/React.createElement(BulletList, null, /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_included_upload_files')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_included_edit_delete_content')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_included_reorder_content'))), /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "p"
  }, t('modal_allow_content_contribution_abilities_excluded_subheading')), /*#__PURE__*/React.createElement(BulletList, null, /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_excluded_edit_name')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_excluded_edit_delete_content')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_excluded_add_sections')), /*#__PURE__*/React.createElement(React.Fragment, null, t('modal_allow_content_contribution_abilities_excluded_view_analytics'))))), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    round: true
  }, t('actions_got_it')))));
}
export default ContentContributionsModal;